module.exports = __webpack_public_path__ + "static/img/SH.f6f806da.svg";